import { AmbientConversation } from "../../api/ambientConversation.type";
import { SubmitButton } from "../shared/buttons/submit-button";
import Typography from "../shared/typography";

export function AmbientConvoListItem({
  item,
  onSelect,
}: {
  item: AmbientConversation;
  onSelect: (id: string) => void;
}) {
  return (
    <li className="flex items-center justify-between py-2">
      <div className="truncate">
        <Typography className="font-medium">
          {item.title || "Untitled"}
        </Typography>
        <Typography variant="caption" className="opacity-70">
          {new Date(item.created_at).toLocaleString()}
        </Typography>
      </div>
      <SubmitButton size="sm" onClick={() => onSelect(item.id)} hideArrow>
        View
      </SubmitButton>
    </li>
  );
}
